<template>
	<div class="tl-calendar-header">
		<v-toolbar color="white" height="30px">
			<v-toolbar-items>
				<v-btn flat color="primary" class="pa-0 ma-0 btn-prev-day" v-on:click="onClickMovePreviousDay">
					<v-icon>chevron_left</v-icon>前日
				</v-btn>
			</v-toolbar-items>
			<v-spacer></v-spacer>
			<v-toolbar-items style="position: relative;">
				<v-menu
					ref="tl_calendar"
					v-model="tl_calendar"
					:close-on-content-click="false"
					:nudge-right="40"
					lazy
					transition="scale-transition"
					full-width
				>
					<template v-slot:activator="{ on }">
						<v-btn flat color="primary" class="pa-0 ma-0 btn-calendar" v-on="on">
							{{ textDate }}
						</v-btn>
					</template>
					<v-date-picker
						v-model="date"
						no-title
						@input="onSelectDate"
						locale="jp-ja"
						:day-format="date => new Date(date).getDate()"
					></v-date-picker>
				</v-menu>
				<v-btn flat color="primary" class="pa-0 ma-0 btn-today" v-on:click="onClickMoveToday">
					今日
				</v-btn>
			</v-toolbar-items>
			<v-spacer></v-spacer>
			<v-toolbar-items>
				<v-btn flat color="primary" class="pa-0 ma-0 btn-next-day" v-on:click="onClickMoveNextDay">
					翌日<v-icon>chevron_right</v-icon>
				</v-btn>
			</v-toolbar-items>
		</v-toolbar>
	</div>
</template>
<script>
import { strftime } from '../../classes/Const';
import ScheduleTick from '../../classes/ScheduleTick';

export default {
	name: 'TLHeaderCalendar',
	components: {
	},
	data() {
		return {
			tl_calendar: false,
		}
	},
	methods: {
		onSelectDate: function() {
			this.tl_calendar = false;
		},
		onClickMovePreviousDay: function() {
			this.$store.dispatch('setCurrentDatePreviousDay');
		},
		onClickMoveNextDay: function() {
			this.$store.dispatch('setCurrentDateNextDay');
		},
		onClickMoveToday: function() {
			this.$store.dispatch('setCurrentDate', new Date());
		},
	},
	computed: {
		date: {
			get: function() {
				return ScheduleTick.createTickFromDate(this.$store.getters.currentDate).strftime('%Y-%m-%d');
			},
			set: function(d) {
				this.$store.dispatch('setCurrentDate', new Date(d.replace(/-/g, '/')));
			},
		},
		textDate: function() {
			return ScheduleTick.createTickFromDate(this.$store.getters.currentDate).strftimeDCL('%Y年%m月%d日(%A)');
		},
	},
}
</script>
<style>
	.tl-calendar-header {
		position: relative;
		width: 100%;
		z-index: 101;
	}
</style>
<style scoped>
	.btn-calendar {
		min-width: 145px;
		margin: 0px 30px !important;
	}
	.btn-next-day, .btn-prev-day {
		min-width: 40px;
	}
	.btn-today {
		position: absolute;
		right: 0px;
		min-width: 30px;
	}
</style>
